<div class="channel-selector">
  <div class="channel-selector__controls">
    <button
      mat-icon-button
      class="channel-selector__button htv-selectable htv-force-direction"
      (click)="selectPreviousChannel()"
      tabindex="-1">
      <mat-icon>&#xe5cb;</mat-icon>
    </button>

    <div
      class="channel-selector__display htv-selectable htv-force-direction"
      [class.channel-selector__display--dropdown-open]="showDropdown"
      (click)="toggleDropdown()"
      tabindex="-1">
      <div class="channel-selector__logo" *ngIf="selectedChannel?.logoUrl">
        <img [src]="selectedChannel?.logoUrl" />
      </div>
      <div class="channel-selector__info">
        <div class="channel-selector__name mat-body-large">
          {{ selectedChannel?.name || (placeholder | translate) }}
        </div>
        <div class="channel-selector__id mat-body-medium" *ngIf="selectedChannel">
          {{ 'PAGES.CHANNEL_SELECTOR.CHANNEL' | translate }} {{ selectedChannel.id }}
        </div>
      </div>
      <mat-icon class="channel-selector__dropdown-icon">
        {{ showDropdown ? 'keyboard_arrow_up' : 'keyboard_arrow_down' }}
      </mat-icon>
    </div>

    <button
      mat-icon-button
      class="channel-selector__button htv-selectable htv-force-direction"
      (click)="selectNextChannel()"
      tabindex="-1">
      <mat-icon>&#xe5cc;</mat-icon>
    </button>
  </div>

  <div class="channel-selector__dropdown" *ngIf="showDropdown">
    <div class="channel-selector__dropdown-content htv-contain">
      <div class="channel-selector__dropdown-header">
        <span class="mat-title-medium">{{ 'PAGES.CHANNEL_SELECTOR.SELECT_CHANNEL' | translate }}</span>
        <button
          mat-icon-button
          class="channel-selector__close-button htv-selectable htv-force-direction"
          (click)="toggleDropdown()"
          tabindex="-1">
          <mat-icon>&#xe5cd;</mat-icon>
        </button>
      </div>
      <div class="channel-selector__dropdown-list">
        <ng-container *ngFor="let channel of channels; let $index = index">
          <div
            class="channel-selector__dropdown-item htv-selectable htv-autofocus {{ $index === 0 ? 'htv-focus' : '' }}"
            (focus)="focusChannel(channel)"
            (click)="selectChannel(channel)"
            tabindex="-1">
            <div class="channel-selector__dropdown-item-logo" *ngIf="channel.logoUrl">
              <img [src]="channel.logoUrl" />
            </div>
            <div class="channel-selector__dropdown-item-info">
              <div class="channel-selector__dropdown-item-name mat-body-medium">{{ channel.name }}</div>
              <div class="channel-selector__dropdown-item-id mat-body-small">
                {{ 'PAGES.CHANNEL_SELECTOR.CHANNEL' | translate }} {{ channel.id }}
              </div>
            </div>
          </div>
        </ng-container>
      </div>
    </div>
  </div>
</div>
